<template>
  <b-button
    v-if="nextText"
    :ghost="!background"
    small
    :disabled="internalDisabled"
    :aria-disabled="internalDisabled"
    @click="$emit('click', $event)"
  >
    <span>{{ nextText }}</span>
  </b-button>
  <b-button
    v-else
    :ghost="!background"
    small
    :disabled="internalDisabled"
    :aria-disabled="internalDisabled"
    :icon="ArrowRight"
    @click="$emit('click', $event)"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { ArrowRight } from '@bigin/icons-vue'
import { BButton } from '@bigin/components/button'
import { paginationNextProps } from './next'

defineOptions({
  name: 'BPaginationNext',
})

const props = defineProps(paginationNextProps)

defineEmits(['click'])

const internalDisabled = computed(
  () =>
    props.disabled ||
    props.currentPage === props.pageCount ||
    props.pageCount === 0
)
</script>
